import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberThirdpartyliability = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 4.42a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M24.186 17.947c2.004-2.28 4.778-3.527 7.814-3.527s5.81 1.247 7.814 3.527C41.813 20.222 43 23.47 43 27.42a1 1 0 0 1-1 1H22a1 1 0 0 1-1-1c0-3.95 1.187-7.198 3.186-9.473M23.03 26.42h17.94c-.18-3.07-1.19-5.48-2.66-7.153-1.62-1.844-3.846-2.847-6.31-2.847s-4.69 1.002-6.311 2.847c-1.47 1.673-2.48 4.083-2.66 7.153M11.7 37.58a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M3.886 51.108c2.004-2.28 4.778-3.528 7.814-3.528s5.81 1.248 7.814 3.528c1.999 2.275 3.186 5.522 3.186 9.472a1 1 0 0 1-1 1h-20a1 1 0 0 1-1-1c0-3.95 1.187-7.197 3.186-9.472M2.73 59.58h17.94c-.18-3.07-1.19-5.48-2.66-7.152-1.621-1.845-3.847-2.848-6.311-2.848s-4.69 1.003-6.311 2.848c-1.47 1.672-2.48 4.082-2.66 7.152m49.572-22a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M44.486 51.108c2.004-2.28 4.778-3.528 7.814-3.528s5.81 1.248 7.814 3.528c1.999 2.275 3.186 5.522 3.186 9.472a1 1 0 0 1-1 1h-20a1 1 0 0 1-1-1c0-3.95 1.187-7.197 3.186-9.472M43.33 59.58h17.94c-.18-3.07-1.19-5.48-2.66-7.152-1.621-1.845-3.847-2.848-6.311-2.848s-4.69 1.003-6.311 2.848c-1.47 1.672-2.48 4.082-2.66 7.152M20.39 44.34a1 1 0 0 1 1-1h21.22a1 1 0 1 1 0 2H21.39a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M25.427 40.745a1 1 0 0 1-.082 1.412l-2.451 2.183 2.451 2.183a1 1 0 0 1-1.33 1.494l-3.29-2.93a1 1 0 0 1 0-1.494l3.29-2.93a1 1 0 0 1 1.412.082m13.146 0a1 1 0 0 1 1.412-.082l3.29 2.93a1 1 0 0 1 0 1.494l-3.29 2.93a1 1 0 0 1-1.33-1.494l2.451-2.183-2.451-2.183a1 1 0 0 1-.082-1.412M32 30.41a1 1 0 0 1 1 1v12.93a1 1 0 1 1-2 0V31.41a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 30.41a1 1 0 0 1 .747.335l2.93 3.29a1 1 0 0 1-1.494 1.33L32 32.913l-2.183 2.452a1 1 0 0 1-1.494-1.33l2.93-3.29A1 1 0 0 1 32 30.41",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberThirdpartyliability;
